import { CardD } from '@atmi/models/cards/card-d';
import { createStore } from '@ngneat/elf';
import {
  addEntities,
  deleteEntities,
  selectAllEntities,
  setEntities,
  updateEntities,
  withEntities
} from '@ngneat/elf-entities';

export const store = createStore({ name: 'beneD' }, withEntities<CardD>());

export const beneD$ = store.pipe(selectAllEntities());

export function setAllD(cards: CardD[]) {
  store.update(setEntities(cards));
}

export function addD(card: CardD) {
  store.update(addEntities(card));
}

export function updateD(id: CardD['id'], card: Partial<CardD>) {
  store.update(updateEntities(id, card));
}

export function deleteD(id: CardD['id']) {
  store.update(deleteEntities(id));
}

